import {
  AbilityBuilder,
  createMongoAbility,
  MongoAbility,
  RawRuleOf,
} from "@casl/ability";
import { Action, Subject } from "@aitisal/contracts/common";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type AppAbility = MongoAbility<[Action, Subject]>;
type RawAppRule = RawRuleOf<AppAbility>;

type CommonStoreState = {
  ability: AppAbility;
  rules: RawAppRule[];
  setAbility: (ability: AppAbility) => void;
};

export const useAbilityStore = create<CommonStoreState>()(persist(
  (set, get) => ({
    // Initially set an empty ability
    ability: createMongoAbility([]) as AppAbility,
    rules: [],
    setAbility: (ability: AppAbility) => {
      const rules = ability.rules as RawAppRule[];
      set(() => ({ ability, rules }));
    },
  }),
  {
    name: "ability-storage",
    partialize: (state) => ({
      rules: state.rules,
    }),
    onRehydrateStorage: () => (state) => {
      if (state?.rules) {
        // Recreate ability from persisted rules
        const ability = createMongoAbility(state.rules) as AppAbility;
        state.ability = ability;
      }
    },
  }
));

// Function to create abilities based on roles
export function createAbilities(roles: any[]): AppAbility {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);
  roles.forEach((role) => {
    can(role.action, role.subject);
  });
  return build();
}